'use client';

import * as React from 'react';
import { cn } from '@shared/utils';
import { withPlatformComponents, WithPlatformComponents } from '../../platform';

/**
 * @group Components
 * 
 * @summary
 * Second path of the Phila logo - left side shape
 * 
 * @example
 * ```typescript
 * <LogoPath2 size={32} className="text-brand" />
 * ```
 */
interface LogoPath2Props {
  size?: number;
  className?: string;
  color?: string;
}

const LogoPath2Component: React.FC<LogoPath2Props & WithPlatformComponents> = ({ 
  size = 32, 
  color = "#1A5167",
  className,
  components 
}) => {
  const { Svg, Path } = components;
  // LogoPath2 bounding box (left side path)
  // Path spans roughly x: 50–320, y: 230–390
  const pathMinX = 50;
  const pathMinY = 225;
  const pathWidth = 275;
  const pathHeight = 170;
  const aspectRatio = pathWidth / pathHeight;
  
  const width = size * aspectRatio;
  const height = size;

  return (
    <Svg
      width={width}
      height={height}
      viewBox={`${pathMinX} ${pathMinY} ${pathWidth} ${pathHeight}`}
      xmlns="http://www.w3.org/2000/svg"
      fill={color}
      className={cn("inline-block", className)}
      style={{ verticalAlign: 'middle' }}
    >
      <Path className="cls-1" d="M113.98,240.33c-31.57,8.5-53.31,34.76-59.04,70.06-4.28,26.37,4.52,53.69,23.56,72.95,33.84,34.24,89.85,35.36,125.1,2.49,2.22-2.07,4.43-4.13,6.65-6.2,5.72-5.33,11.43-10.66,17.15-15.99,7.82-7.29,15.64-14.58,23.46-21.87,8.53-7.95,17.06-15.9,25.59-23.85,7.84-7.31,15.69-14.62,23.53-21.93,5.76-5.37,11.52-10.74,17.28-16.11.02-.02.04-.04.06-.06,2.23-2.08,1.41-5.79-1.49-6.7-.08-.02-.16-.05-.23-.07-3.55-1-7.1-1.94-10.67-2.85-7.91-2-15.89-3.72-23.89-5.33-21.94-4.41-43.86-8.56-65.7-13.5-9.53-2.16-19.06-4.34-28.6-6.48-23.59-5.29-48.79-11.01-72.76-4.56Z"/>
    </Svg>
  );
};

export const LogoPath2 = withPlatformComponents(LogoPath2Component);
